<!-- TEMPLATE -->
<template>
  <div class="admin-users-summary">
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
          <span slot='title'>
              <span class='avenir-heavy'>Gebruikers</span>
          </span>
        </dean-section-title>
        <div class="filter">
          <dean-form-row
              @input="update()"
              v-model="pageMeta.query"
              class="search-input"
              hide-label="true"
          >Zoeken op e-mail of naam
          </dean-form-row>
        </div>
        <dean-table
            :data='data'
            :columns="columns"
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick">
        </dean-table>
        <dean-pagination
            :current-page='userMetaData.pageNumber'
            :total-items='userMetaData.totalResults'
            :items-per-page='userMetaData.itemsPerPage'
            :select-items-per-page='selectItemsPerPage'
            :visible-pages='userMetaData.visiblePages'
            @page-changed='paginationChanged'
            @items-per-page='itemsPerPageChanged'
        >
        </dean-pagination>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import {Vue, Component} from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuAdminMixin from '@/mixins/sideMenuAdminMixin';
  import {mixins} from 'vue-class-component';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';

  import {
    plusIcon,
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanSectionTitle,
      deanSectionTitleItem,
      deanTable,
      deanPagination,
      deanFormRow,
    },
  })

  export default class List extends mixins(deanTableMixin, sideMenuAdminMixin) {
    // DATA
    public plusIcon: object = plusIcon;
    public queryTimeout!: number;
    public data: Array<{
      id: string;
      fullName: string;
      email: string;
      createdAt: string;
    }> = [];

    public columns: any = {
      id: {
        content: 'ID',
        align: 'left',
        sort: true,
        dql: 'id',
      },
      email: {
        content: 'E-mailadres',
        align: 'left',
        sort: true,
        dql: 'email',
      },
      fullName: {
        content: 'Volledige naam',
        align: 'left',
        sort: true,
        dql: 'fullName',
      },
      createdAt: {
        content: 'Aangemaakt op',
        align: 'left',
        sort: true,
        dql: 'createdAt',
      },
    };

    // COMPUTED
    get userMetaData() {
      return this.pageMeta;
    }

    public tableName(): string {
      return 'auth-users';
    }

    // METHODS
    public update() {
      this.pageMeta.pageNumber = 1;

      if (this.queryTimeout) {
        clearTimeout(this.queryTimeout);
      }

      this.queryTimeout = setTimeout(() => {
        this.loadList(this.pageMeta);
      }, 400);
    }

    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const requestData: any = {
        meta: {
          startIndex: this.startIndex,
          numberOfItems: data.itemsPerPage,
        },
        sort: data.sort,
        search: data.query,
      };

      axios.post('/-/trade/api/admin.users.list', requestData)
          .then(
            (response) => {
              this.data = response.data.data;
              this.updateMeta(response.data.meta);
            },
            (error) => {
              this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
            },
          ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public cellClick(target: any) {
      this.$router.push({
        name: 'auth.admin.user.edit',
        params: {id: target.row.id},
      });
    }

    public sectionRoute(name: string) {
      this.$router.push({name});
    }

    public created() {
      this.setDefaultSort('fullName');
      this.loadList(this.pageMeta);
      this.buildSideMenuAdmin();
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>
  .filter {
    margin-bottom: 0.25rem;
  }

  .search-input {
    max-width: 250px;
  }

  :deep(.search-input .hd-6.columns) {
    width: 100%;
  }
</style>
